import { SCDesctiption } from 'pages/style/typography/titlePage';
import { ReactNode } from 'react';
import { Row, Col } from 'react-bootstrap';

type PropsHeaderCrud = {
  title: string
  children: ReactNode
}

const HeaderCrud: React.FC<PropsHeaderCrud> = ({ title, children }: PropsHeaderCrud) => {

  return (
    <div className="mx-5">
      <Row>
        <Col>
          <SCDesctiption>{title}</SCDesctiption>
        </Col>
        <Col className='d-flex align-items-center justify-content-end'>
          {children}
        </Col>
      </Row>
    </div>
  );
};

export default HeaderCrud;